<div href="" class="card add-card">
    <div class="thumb"></div>
    <div>
      <div class="add-icon">
          +
      </div>
    </div>